export interface FAQItem {
  question: string;
  answer: string;
}

export const faqData: FAQItem[] = [
  {
    question: "What is Dualite and how does it work?",
    answer: "Dualite is an AI platform that allows non-tech people to build apps and websites - without the need to look into code. Simply describe what you want to build in natural language, and Dualite handles the rest."
  },
  {
    question: "What can I build with Dualite?",
    answer: "You can build websites, mobile apps, dashboards, e-commerce sites, SaaS tools, internal business applications, and more."
  },
  {
    question: "How does Dualite's pricing work?",
    answer: "We offer plans starting at $29/month for 200 messages, and $79/month for unlimited messages to build stress-free. You can also purchase additional credits as needed."
  },
  {
    question: "Do I need to know coding to use Dualite?",
    answer: "Not at all! Dualite is designed for anyone to build any kind of software with zero coding required. You simply describe what you want to build, and Dualite handles the rest."
  },
  {
    question: "How is Dualite different from other such platforms?",
    answer: "While most platforms stop at single-page mockups or prototypes, Dualite delivers fully functional, production-ready applications. Moreover, we have a Launch plan that offers unlimited messages."
  }
];

